import { Component } from '@angular/core';

@Component({
  selector: 'app-upload-dte',
  templateUrl: './upload-dte.component.html',
  styleUrls: ['./upload-dte.component.scss', '../../../../../assets/css/tabs.scss']
})
export class UploadDteComponent {
  history = 1;
}
